import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login.vue'
import store from '@/store'
import adminRoutes from './admin'
import deviceRoutes from './device'
import stationRoutes from './station'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/stations'
    },
    {
      path: '/stations',
      name: 'stations',
      component: () => import(/* webpackChunkName: "stations" */ '@/views/Stations.vue'),
      meta: {
        requiresAuth: true,
        noMenu: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/schema-new',
      name: 'schema-new',
      component: () => import(/* webpackChunkName: "schema" */ '@/views/SchemaNew.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/map',
      name: 'map',
      component: () => import(/* webpackChunkName: "map" */ '@/views/Map.vue'),
      meta: {
        requiresAuth: true,
        noMenu: true
      }
    },
    ...adminRoutes,
    ...deviceRoutes,
    ...stationRoutes
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters[ 'security/isAuthenticated' ]) {
      next()
    } else {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  } else {
    next()
  }
})

export default router
